import React, { Children, useContext } from 'react';
import { Row, Col, Label, InputGroup, Input } from 'reactstrap';
import DynamicInput from '../common/DynamicInput';
import { UserSettingsContext } from 'contexts/UserSettingsContext';
import IconButton from './IconButton';

const IconInputSwitch = ({ type, label, text, iconKey, md, xl, children}) => {
    const { userSettings, updateSetting } = useContext(UserSettingsContext);
    const toggleIcons = () => {
        updateSetting('show_icons', !userSettings.show_icons)
    }
    
    if(userSettings.show_icons){
        if(text){
            return (
                <Row>
                    <Col className="d-flex align-items-center pl-2">
                        { iconKey ? 
                            <IconButton translationId={label} icon={iconKey}/>
                        : 
                            <label>{label}</label>
                        }
                        {text &&
                            <Label>{text}</Label>
                        }
                    </Col>
                    <Col className="d-flex align-items-center pl-2">
                    {children}
                    </Col>
                </Row>
            );
        }
        return (
            <Col md={md} xl={xl} className="d-flex align-items-center pl-2">
                <InputGroup>
                    { iconKey ? 
                        <IconButton translationId={label} icon={iconKey}/>
                    : 
                        <label>{label}</label>
                    }
                    {text &&
                        <Label>{text}</Label>
                    }
                    {children}
                </InputGroup>
            </Col>
        );
    }
    return (
        <Col md={md} xl={xl} className="pl-2">
            <label onClick={toggleIcons}>{text || label}</label>
            {type === 'link' ? 
                <InputGroup>
                    {children}
                </InputGroup>
            : 
                children
            }
        </Col>
    );
};

export default IconInputSwitch;

